import { render, staticRenderFns } from "./SystemSetting.vue?vue&type=template&id=00227b58&scoped=true"
import script from "./SystemSetting.vue?vue&type=script&lang=js"
export * from "./SystemSetting.vue?vue&type=script&lang=js"
import style0 from "./SystemSetting.vue?vue&type=style&index=0&id=00227b58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00227b58",
  null
  
)

export default component.exports